import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import NoteIcon from '@material-ui/icons/Note';
import ProjectNoteDialog from './ProjectNoteDialog';
const useStyles = makeStyles((theme) => ({
    button: {
      marginRight: theme.spacing(1),
    },
  }));
export default function ButtonNote({ projectId }) {
    const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        className={classes.button}
        // variant="outlined"
        color="primary"
        endIcon={<NoteIcon />}
        onClick={handleOpen}
        alt="Give a note for this project"
        title="Give a note for this project"
      >
        Notes
      </Button>
      <ProjectNoteDialog
        open={open}
        onClose={handleClose}
        projectId={projectId}
      />
    </>
  );
} 